import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    userBalance: '',
    coinList: []
  },
  getters: {},
  mutations: {
    setUserBalance(state, payload) {
      state.userBalance = payload;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    }
  },
  actions: {
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    getBalance({ commit }, content) {
      api.getBalance(content).then(({ data }) => {
        commit('setUserBalance', data);
      });
    }
  }
};

appStore.registerModule('balanceSearch', store);
